import React from 'react';
import {
  createUserWidgets,
  deleteUserWidgets,
  getUserWidgets,
  getWidgetTypes,
  updateUserWidgets,
} from '../../../../api/widget';
import noti from '../../../../actions/toast';
import Loading from '../../../Helpers/Loading';
import Backend from '../../../Layouts/Backend';
import {
  convertToStandard,
  getAvailableWidgets,
  initWidgets,
} from './functions';
import './customize-dashboard.scss';
import DashboardCustomProperties from './DashboardCustomProperties';
import WidgetList from './WidgetList';
import { useFormik } from 'formik';
import { cloneDeep, orderBy } from 'lodash';
import DashboardCustomPreview from './DashboardCustomPreview';
import { Button } from '../../../UI/Common';
import { v4 as uuidv4 } from 'uuid';
import { dashboardCustomizeConstants } from './constants';
import {
  getAlarmList,
  getMobileAlarmListByMC,
} from '../../../../api/dashboard';
import { getGroups } from '../../../../api/group';

const DashboardCustom = (props) => {
  const [isLoading, setIsLoading] = React.useState(true);
  const [isActive, setIsActive] = React.useState('');
  const [originalWidgets, updateOriginalWidgets] = React.useState([]);
  const [usingWidgets, updateUsingWidgets] = React.useState([]);
  const [availableWidgets, updateAvailableWidgets] = React.useState([]);
  const [shouldDisplayCMV, updateShouldDisplayCMV] = React.useState(false);
  const [alarms, updateAlarms] = React.useState([]);
  const [monitoringPoints, updateMonitoringPoints] = React.useState([]);
  const [groups, updateGroups] = React.useState([]);
  const formik = useFormik({
    initialValues: [],
  });
  React.useEffect(() => {
    setIsLoading(true);
    getUserWidgets()
      .then((resp) => {
        updateOriginalWidgets(resp);
        if (resp.length) {
          const _resp = convertToStandard(cloneDeep(resp));
          updateUsingWidgets(orderBy(_resp, ['index'], 'asc'));
        }
      })
      .catch((err) => console.log('get user widgets error', err));

    getWidgetTypes()
      .then((widgetTypes) => {
        updateAvailableWidgets(
          initWidgets(
            widgetTypes.filter(
              (widgetType) =>
                widgetType.name !== dashboardCustomizeConstants.widget3,
            ),
          ),
        );
      })
      .catch((err) => console.log('get widget type error', err));
    getAlarmList()
      .then((resp) => updateAlarms(resp))
      .catch((err) => console.log('get alarm error', err));
    getMobileAlarmListByMC()
      .then((resp) => updateMonitoringPoints(resp))
      .catch((err) => console.log('get monitoring points error', err));
    getGroups()
      .then((resp) => updateGroups(resp.items))
      .catch((err) => console.log('get groups error', err));
    setIsLoading(false);
  }, []);

  function mergeChange(values) {
    const _usingWidgets = cloneDeep(usingWidgets);
    _usingWidgets.map((obj) => {
      if (obj.id === values.id) {
        Object.assign(obj, values);
      }
    });
    updateUsingWidgets(_usingWidgets);
  }

  function addWidget(widget) {
    const maxZindex = usingWidgets.length
      ? Math.max.apply(
          Math,
          usingWidgets.map(function (obj) {
            return obj.index + 1;
          }),
        )
      : 0;
    updateUsingWidgets((usingWidgets) => [
      ...usingWidgets,
      { ...widget, index: maxZindex, id: uuidv4() },
    ]);
    // updateAvailableWidgets((availableWidgets) =>
    //   availableWidgets.filter(
    //     (availableWidget) => availableWidget.id !== widget.id,
    //   ),
    // );
  }
  function removeWidget(widget) {
    updateUsingWidgets((usingWidgets) =>
      usingWidgets.filter((usingWidget) => usingWidget.id !== widget.id),
    );
    // updateAvailableWidgets((availableWidgets) => [
    //   ...availableWidgets,
    //   { ...widget },
    // ]);
  }
  function reorderWidget(result) {
    const _result = cloneDeep(result).map((res, index) => ({ ...res, index }));
    updateUsingWidgets(_result);
  }
  function onSave() {
    if (originalWidgets.length) {
      usingWidgets.forEach((widget) => {
        if (
          originalWidgets
            .map((originalWidget) => originalWidget.id)
            .includes(widget.id)
        ) {
          updateUserWidgets(widget)
            .then(() =>
              noti.success(`Update ${widget.widgetTypeName} successfully`),
            )
            .catch(() =>
              noti.error(`Update ${widget.widgetTypeName} unsuccessfully`),
            );
        } else {
          createUserWidgets(widget)
            .then(() =>
              noti.success(`Create ${widget.widgetTypeName} successfully`),
            )
            .catch(() =>
              noti.error(`Create ${widget.widgetTypeName} unsuccessfully`),
            );
        }
      });
      originalWidgets
        .filter(
          (originalWidget) =>
            !usingWidgets
              .map((usingWidget) => usingWidget.id)
              .includes(originalWidget.id),
        )
        .forEach((originalWidget) =>
          deleteUserWidgets(originalWidget.id)
            .then(() =>
              noti.success(
                `Delete ${originalWidget.widgetTypeName} successfully`,
              ),
            )
            .catch(() =>
              noti.error(
                `Delete ${originalWidget.widgetTypeName} unsuccessfully`,
              ),
            ),
        );
    } else {
      usingWidgets.forEach((usingWidget) =>
        createUserWidgets(usingWidget)
          .then(() =>
            noti.success(`Create ${usingWidget.widgetTypeName} successfully`),
          )
          .catch(() =>
            noti.error(`Create ${usingWidget.widgetTypeName} unsuccessfully`),
          ),
      );
    }
  }
  function goBack() {
    props.history.goBack(-1);
  }

  if (isLoading) {
    return (
      <Backend>
        <div className="content-inner">
          <Loading />
        </div>
      </Backend>
    );
  }

  return (
    <Backend>
      <div className="content-inner">
        <div className="d-flex flex-column flex-1 h-100 position-relative">
          <div className="d-flex flex-1 position-relative">
            <WidgetList
              isActive={isActive}
              setIsActive={setIsActive}
              usingWidgets={usingWidgets}
              availableWidgets={availableWidgets}
              onAddWidget={addWidget}
              onRemoveWidget={removeWidget}
              onReorderWidget={reorderWidget}
            />
            <DashboardCustomPreview
              usingWidgets={usingWidgets}
              isActive={isActive}
              shouldDisplayCMV={shouldDisplayCMV}
              updateShouldDisplayCMV={updateShouldDisplayCMV}
            />
            {isActive === '' ? null : (
              <div className="properties-section">
                <DashboardCustomProperties
                  properties={
                    usingWidgets.filter((val) => val.id === isActive)[0]
                  }
                  onChange={mergeChange}
                  monitoringPoints={cloneDeep(monitoringPoints)}
                  alarms={cloneDeep(alarms)}
                  setIsActive={setIsActive}
                  groups={cloneDeep(groups)}
                />
              </div>
            )}
          </div>
          <div className="d-flex mt-10">
            <Button color="primary" classes="m-1" onClick={onSave}>
              <i className="md-icon">done</i>
              Save
            </Button>
            <Button classes="m-1" onClick={() => props.history.goBack(-1)}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </Backend>
  );
};

export default DashboardCustom;
